import styled from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

export const Wrapper = styled.div`
  padding: 20px;
  font-family: ${font.text};
  color: ${colors.ink};

  @media (min-width: 1280px) {
    padding: 25px;
  }
`;

// Сам документ — білий «аркуш» зручної ширини для читання
export const Document = styled.article`
  max-width: 820px;
  padding: 36px 40px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  border: 1px solid ${colors.line};
  box-shadow: ${shadow.card};
  font-size: 15px;
  font-weight: 500;
  line-height: 1.7;

  @media (max-width: 768px) {
    padding: 22px 18px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 4px;
`;

export const Subtitle = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.muted};
  margin-bottom: 24px;
`;

export const SectionTitle = styled.h3`
  font-size: 17px;
  font-weight: 800;
  margin: 28px 0 10px;
  padding-top: 20px;
  border-top: 1px solid ${colors.line};
`;

export const Paragraph = styled.p`
  margin-bottom: 10px;
  color: ${colors.ink};
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  color: ${colors.ink};

  b {
    font-weight: 700;
  }
`;
